<template>
    <div>
        <FullCalendar
            ref="fullCalendar"
            defaultView="timeGridDay"
            :plugins="calendarPlugins"
            :options="calendarOptions"

            />


    </div>






</template>








<script>

import '@fullcalendar/core/vdom'
import FullCalendar, { CalendarOptions, EventApi, DateSelectArg, EventClickArg } from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import esLocale from '@fullcalendar/core/locales/es'
import listPlugin from '@fullCalendar/list'
import {mapGetters} from 'vuex'
import { thisTypeAnnotation, throwStatement } from '@babel/types'



    export default {
        name: 'Calendar',
        props: ["grupo_id"],
        components: {
            FullCalendar,
        },


        data() {
            return {
            eventGuid : 0,
            id:0,
               calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
            ],
            calendarWeekends: false,
          // opciones del calendario

          calendarOptions: {
               plugins: [dayGridPlugin,timeGridPlugin,interactionPlugin],
               initialView: 'dayGridMonth',
               locale: esLocale,
               headerToolbar: {
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },

                selectMirror: true,
                weekends: true,

                events:[],


           },

        };
    },




  mounted() {
    this.grupo=this.grupo_id
    console.log(this.grupo)
    axios.get("/calendar/appointments/agenda_grupo/"+this.grupo+"/")
            .then(response => {
                  this.calendarOptions.events=response.data.events

            })
            .catch(function (error) {
                     console.log('uppps 1')
                 })


    },

};




    </script>

